import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { Router } from '@angular/router';
import { AddCountryModal } from '../modals/add-country-modal/add-country-modal.component';
@Component({
  selector: 'app-geofencing-management',
  templateUrl: './geofencing-management.component.html',
  styleUrls: ['./geofencing-management.component.scss'],
})
export class GeofencingManagementComponent implements OnInit {
  constructor(
    private location: Location,
    private router: Router,
    private modalService: SuiModalService
  ) {}

  ngOnInit(): void {
    // console.log(this.router.url, 'url');
  }

  goBack() {
    this.router.navigate(['/admin/setting/application-security']);
  }

  isAddCountryRoute(): boolean {
    if (
      this.router.url ==
        '/admin/setting/application-security/geofence-management/global-settings/allowed-countries' ||
      this.router.url ==
        '/admin/setting/application-security/geofence-management/global-settings/disallowed-countries'
    ) {
      return true;
    } else {
      return false;
    }
  }

  addCountry() {
    if (
      this.router.url ==
      '/admin/setting/application-security/geofence-management/global-settings/disallowed-countries'
    ) {
      this.modalService
        .open(
          new AddCountryModal(
            'Add Country',
            { isCountryAllowed: false },
            ModalSize.Tiny
          )
        )
        .onApprove((payload) => {
          location.reload();
        })
        .onDeny(() => {});
    }
    if (
      this.router.url ==
      '/admin/setting/application-security/geofence-management/global-settings/allowed-countries'
    ) {
      this.modalService
        .open(
          new AddCountryModal(
            'Add Country',
            { isCountryAllowed: true },
            ModalSize.Tiny
          )
        )
        .onApprove((payload) => {
          location.reload();
        })
        .onDeny(() => {});
    }
  }
}
